import { useEffect } from 'react';
import { fetchAppConfig } from '../api';
import { useStore } from '../store';

// One-shot fetch on mount: pulls the list of base domains the deployment
// supports and pushes it into the domain slice. If the persisted base isn't
// in the list (e.g. removed at deploy time), reset to the first available.
export function AppConfigLoader() {
  const setAvailableDomains = useStore((s) => s.setAvailableDomains);
  const setDomainBase = useStore((s) => s.setDomainBase);

  useEffect(() => {
    let cancelled = false;
    fetchAppConfig()
      .then((cfg) => {
        if (cancelled) return;
        setAvailableDomains(cfg.domains);
        useStore.getState().setRepoUrl(cfg.repoUrl ?? null);
        const current = useStore.getState().domainBase;
        if (cfg.domains.length > 0 && !cfg.domains.includes(current)) {
          setDomainBase(cfg.domains[0]!);
        }
      })
      .catch(() => {
        /* offline / dev: keep defaults */
      });
    return () => {
      cancelled = true;
    };
  }, [setAvailableDomains, setDomainBase]);

  return null;
}
